module.exports = __webpack_public_path__ + "static/img/meeting-default.48f53c0a.png";